import * as R from 'ramda';

const defaultState = {
  byId: {},
  draftsById: {},
  keyWindows: [],
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case 'SAVE_CATEGORY':
    case 'FETCH_CATEGORY':
    case 'CREATE_CATEGORY':
    case 'REMOVE_CATEGORY':
      return {
        ...state,
        keyWindows: [...new Set([...state.keyWindows, action.payload.keyWindow])],
        [action.payload.keyWindow]: {
          ...state[action.payload.keyWindow],
          isLoading: true,
        },
      };
    case 'NEW_CATEGORY':
      return {
        ...state,
        keyWindows: [...new Set([...state.keyWindows, action.payload.keyWindow])],
        [action.payload.keyWindow]: {
          ...state[action.payload.keyWindow],
          isNew: true,
        },
      };
    case 'EDIT_CATEGORY':
      return {
        ...state,
        keyWindows: [...new Set([...state.keyWindows, action.payload.keyWindow])],
        [action.payload.keyWindow]: {
          ...state[action.payload.keyWindow],
          isEdit: true,
        },
      };
    case 'UNDO_EDIT_CATEGORY':
      return {
        ...state,
        keyWindows: [...new Set([...state.keyWindows, action.payload.keyWindow])],
        [action.payload.keyWindow]: {
          ...state[action.payload.keyWindow],
          isEdit: false,
        },
      };
    case 'RECEIVE_ENTITIES':
      return {
        ...state,
        byId: {
          ...state.byId,
          ...R.path(['payload', 'entities', 'categories', 'byId'], action),
        },
        keyWindows: [...new Set([...state.keyWindows, action.payload.keyWindow])],
        [action.payload.keyWindow]: {
          ...state[action.payload.keyWindow],
          isLoading: false,
          isNew: false,
          isEdit: false,
          ids: R.path(['payload', 'entities', 'categories', 'ids'], action),
        },
      };
    case 'RECEIVE_ERRORS':
      return {
        ...state,
        keyWindows: [...new Set([...state.keyWindows, action.payload.keyWindow])],
        [action.payload.keyWindow]: {
          ...state[action.payload.keyWindow],
          isLoading: false,
        },
      };
    case 'RELEASE_KEY_WINDOW':
      return {
        ...R.omit([action.payload.keyWindow], state),
        keyWindows: state.keyWindows.filter(kw => kw !== action.payload.keyWindow),
      };
    default:
      return state;
  }
}
